import { jsxs as e, jsx as o } from "react/jsx-runtime";
const n = ({ className: t }) => /* @__PURE__ */ e(
  "svg",
  {
    width: "41",
    height: "41",
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: t,
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M26.9961 28.5554L15.3294 28.5554",
          stroke: "#A8A29E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M26.9961 21.8888L21.9961 21.8888",
          stroke: "#A8A29E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M34.4961 23.5555C34.4961 29.8409 34.4961 32.9836 32.4214 34.9362C30.3468 36.8888 27.0077 36.8888 20.3294 36.8888H19.0415C13.6062 36.8888 10.8885 36.8888 9.00121 35.5591C8.46046 35.1781 7.98039 34.7263 7.57559 34.2173C6.16276 32.441 6.16276 29.8832 6.16276 24.7676V20.5252C6.16276 15.5865 6.16276 13.1172 6.94432 11.145C8.20078 7.9745 10.858 5.4736 14.2267 4.29105C16.3221 3.55546 18.9458 3.55546 24.1931 3.55546C27.1915 3.55546 28.6907 3.55546 29.8881 3.97579C31.8131 4.65154 33.3315 6.08062 34.0495 7.89236C34.4961 9.01933 34.4961 10.4304 34.4961 13.2524V23.5555Z",
          stroke: "#A8A29E",
          strokeWidth: "1.5",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M6.16536 20.2222C6.16536 17.1539 8.65267 14.6666 11.7209 14.6666C12.8306 14.6666 14.1388 14.861 15.2176 14.572C16.1762 14.3151 16.925 13.5664 17.1818 12.6078C17.4709 11.5289 17.2765 10.2207 17.2765 9.11106C17.2765 6.04281 19.7638 3.5555 22.832 3.5555",
          stroke: "#A8A29E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
export {
  n as FileIcon
};
